//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';
import { CalendarBookingInputItem } from './CalendarBookingInputItem';

export class StudentSignupInputItem extends ItemBase {
    Birthday: string | null = null;
    EmailAddress: string | null = null;
    FaceTimeID: string | null = null;
    FirstName: string | null = null;
    Gender: string | null = null;
    IsAdult: boolean = false;
    LastName: string | null = null;
    LocalSchool: string | null = null;
    PreferredTeacherID: string | null = null;
    SkillLevel: string | null = null;
    SkypeUsername: string | null = null;
    SubjectTagID?: string | null;
    TelephoneNumber: string | null = null;
    CustomFieldValues: CustomFieldValueInputItem[] = [];
    BookingRequest: CalendarBookingInputItem | null = null;

    constructor(initializer?: Partial<StudentSignupInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentSignupInputItem";
}
